const emailValidationRegex =
  /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/

const phoneNumberRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/

const wholeIntergerRegex = /^-?\d+$/

const decimalNumberRegex = /^-?\d+\.?(\d{1,2})?$/

const fieldMaskEligibleChar = /^-?[09AaLl?*]+$/

export const validateEmail = emailAddress => {
  return emailValidationRegex.test(emailAddress)
}

export const validatePhoneNumber = phonenumber => {
  return phoneNumberRegex.test(phonenumber)
}

export const validateWholeInteger = interger => {
  if (interger) {
    return wholeIntergerRegex.test(interger)
  }
  return true
}

export const validateDecimalNumber = number => {
  return decimalNumberRegex.test(number)
}

export const validateFieldMask = mask => {
  if (mask) {
    // Check for invalid characters
    if (!fieldMaskEligibleChar.test(mask)) {
      return 'Field Mask can only contain the following characters: 0, 9, A, a, L, l, ?, *'
    }
    // Check wildcard count and positioning
    const wildcardCount = mask.split('*').length - 1
    if (wildcardCount > 1) {
      return 'Only one wildcard character (*) is allowed'
    }
    if (wildcardCount === 1 && mask[0] !== '*' && mask[mask.length - 1] !== '*') {
      return 'Wildcard (*) must be the first or last character'
    }
  }
  return false
}
